import React from 'react';
import logoSvg from '@/public/1775543.svg';

/**
 * Premium Logo
 */
export const CatLogo = ({ size = 'md', showText = true }) => {
  const sizes = { sm: 32, md: 44, lg: 60, xl: 80, xl2: 110 };
  const px = sizes[size] || 44;

  return (
    <div className="flex items-center gap-3">
      <img
        src={logoSvg}
        alt="西蒙的猫"
        width={px}
        height={px}
        className="object-contain"
        style={{ filter: 'drop-shadow(0 4px 20px rgba(61,130,176,0.4))' }}
      />
      {showText && (
        <div className="font-semibold leading-tight">
          <div className="text-base lg:text-lg leading-tight" style={{ color: '#eef3f7', letterSpacing: '0.02em' }}>西蒙的猫</div>
          <div className="text-[10px] leading-tight" style={{ color: '#8898ab', letterSpacing: '0.18em', fontWeight: 500 }}>SIMON&apos;S CAT TRAVEL</div>
        </div>
      )}
    </div>
  );
};

export default CatLogo;
